import React, { createContext, useContext, useState, useEffect } from 'react';
import t from '../i18n/translations';

const AppContext = createContext();

export const DEVISES = [
  { code: 'EUR', label: 'Euro', symbol: '€' },
  { code: 'USD', label: 'Dollar US', symbol: '$' },
  { code: 'XOF', label: 'Franc CFA', symbol: 'FCFA' },
  { code: 'GBP', label: 'Livre sterling', symbol: '£' },
  { code: 'CHF', label: 'Franc suisse', symbol: 'CHF' },
  { code: 'CAD', label: 'Dollar canadien', symbol: 'CA$' },
  { code: 'MAD', label: 'Dirham marocain', symbol: 'MAD' },
  { code: 'TND', label: 'Dinar tunisien', symbol: 'TND' },
  { code: 'DZD', label: 'Dinar algérien', symbol: 'DZD' },
  { code: 'NGN', label: 'Naira', symbol: '₦' },
  { code: 'GHS', label: 'Cedi ghanéen', symbol: 'GH₵' },
  { code: 'KES', label: 'Shilling kenyan', symbol: 'KSh' },
  { code: 'ZAR', label: 'Rand', symbol: 'R' },
  { code: 'CNY', label: 'Yuan', symbol: '¥' },
  { code: 'JPY', label: 'Yen', symbol: '¥' },
  { code: 'AED', label: 'Dirham EAU', symbol: 'AED' },
  { code: 'BRL', label: 'Réal brésilien', symbol: 'R$' },
  { code: 'INR', label: 'Roupie indienne', symbol: '₹' },
];

export const LANGUES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷', dir: 'ltr' },
  { code: 'en', label: 'English', flag: '🇬🇧', dir: 'ltr' },
  { code: 'es', label: 'Español', flag: '🇪🇸', dir: 'ltr' },
  { code: 'pt', label: 'Português', flag: '🇧🇷', dir: 'ltr' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪', dir: 'ltr' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹', dir: 'ltr' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  { code: 'zh', label: '中文', flag: '🇨🇳', dir: 'ltr' },
  { code: 'ja', label: '日本語', flag: '🇯🇵', dir: 'ltr' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺', dir: 'ltr' },
];

export const AppProvider = ({ children }) => {
  const [devise, setDevise] = useState(() => localStorage.getItem('app_devise') || 'EUR');
  const [langue, setLangue] = useState(() => localStorage.getItem('app_langue') || 'fr');

  const [avatar, setAvatar] = useState(() => localStorage.getItem('app_avatar') || null);

  const updateAvatar = (dataUrl) => {
    setAvatar(dataUrl);
    if (dataUrl) localStorage.setItem('app_avatar', dataUrl);
    else localStorage.removeItem('app_avatar');
  };

  // Applique la direction RTL si arabe
  useEffect(() => {
    const lang = LANGUES.find(l => l.code === langue);
    document.documentElement.setAttribute('lang', langue);
    document.documentElement.setAttribute('dir', lang?.dir || 'ltr');
    localStorage.setItem('app_langue', langue);
  }, [langue]);

  useEffect(() => {
    localStorage.setItem('app_devise', devise);
  }, [devise]);

  const deviseInfo = DEVISES.find(d => d.code === devise) || DEVISES[0];

  const formatMontant = (amount) => {
    const num = parseFloat(amount || 0).toFixed(2);
    return `${num} ${deviseInfo.symbol}`;
  };

  return (
    <AppContext.Provider value={{ devise, setDevise, langue, setLangue, deviseInfo, formatMontant, DEVISES, LANGUES, avatar, updateAvatar }}>
      {children}
    </AppContext.Provider>
  );
};


export const useApp = () => useContext(AppContext);



export const useT = () => {
  const { langue } = useApp();
  return (key) => t[langue]?.[key] ?? t['fr'][key] ?? key;
};
